import { FaMinus } from "react-icons/fa";
import { GoPlus } from "react-icons/go";
import { formatErrorMessageV2 } from "../utils";

export type CounterInputV2Props = {
  name: string;
  label?: string;
  value?: string | number;
  min?: number;
  max?: number;
  suffix?: string;
  disabled?: boolean;
  error?: string;
  onChange?: (value: number) => void;
};

export function CounterInputV2({
  name,
  label,
  value = 0,
  min = 0,
  max,
  suffix,
  disabled = false,
  error,
  onChange,
}: CounterInputV2Props) {
  const counterValue = normalizeCounterValue(value, min, max);

  function updateValue(nextValue: number) {
    onChange && onChange(normalizeCounterValue(nextValue, min, max));
  }

  function handleInputChange(nextValue: string) {
    const digits = nextValue.replace(/\D/g, "");
    updateValue(digits ? Number(digits) : min);
  }

  return (
    <div className="ov2-field">
      {label && <span className="ov2-field__label">{label}</span>}
      <span className={`ov2-counter ${error ? "ov2-counter--error" : ""} ${disabled ? "ov2-counter--disabled" : ""}`}>
        <button
          type="button"
          aria-label="Diminuir valor"
          disabled={disabled || counterValue <= min}
          onClick={() => updateValue(counterValue - 1)}
        >
          <FaMinus />
        </button>
        <span className="ov2-counter__input">
          <input
            name={name}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            value={counterValue}
            style={{ width: `${Math.max(String(counterValue).length, 1)}ch` }}
            disabled={disabled}
            onChange={(event) => handleInputChange(event.target.value)}
          />
          {suffix && <span>{suffix}</span>}
        </span>
        <button
          type="button"
          aria-label="Aumentar valor"
          disabled={disabled || (max !== undefined && counterValue >= max)}
          onClick={() => updateValue(counterValue + 1)}
        >
          <GoPlus />
        </button>
      </span>
      {error && <small className="ov2-field__error animation__fadeIn">{formatErrorMessageV2(error)}</small>}
    </div>
  );
}

function normalizeCounterValue(value: string | number | undefined, min = 0, max?: number) {
  const numberValue = Math.floor(Number(value || 0));
  const safeValue = Number.isFinite(numberValue) ? numberValue : min;
  const withMin = Math.max(safeValue, min);
  return max !== undefined ? Math.min(withMin, max) : withMin;
}
